import { useCallback, useEffect, useState } from "react";
import { SpaceModel } from "../interfaces/Space";

type Props = {
    space?: SpaceModel;
    mapbp: any
}

export type MapboxStaticImageReturn = {
    imageSource: string,
    mapsUrl: string
}

const getFormattedAddress = (space: SpaceModel) => {
    if (space.mainAddress) {
        const spaceAddress = space.mainAddress;
        return `${spaceAddress.partOne} ${spaceAddress.partTwo} ${spaceAddress.zipCode} ${spaceAddress.city}`
    } else if (space.properties.address) {
        return space.properties.address;
    }

    return '';
}

const getGoogleMapsUrl = (space: SpaceModel | undefined) => {
    if (!space) return '';
    const address = encodeURIComponent(getFormattedAddress(space));
    const baseUrl = 'https://www.google.com/maps/search/?api=1&query='
    return `${baseUrl}${address}`;
}

export default function UseMapboxStaticImage({ space, mapbp }: Props): MapboxStaticImageReturn {


    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    window.addEventListener('resize', () => {
        if (window.innerWidth !== windowWidth) {
            setWindowWidth(window.innerWidth);
        }
    })

    const [imageSource, setImgSrc] = useState<string>('');
    const [mapsUrl, setMapsUrl] = useState<string>('');

    const getMapboxStaticImageUrl = useCallback((space: SpaceModel) => {

        const setWindowWidth = windowWidth || 800;

        const longitude = space.coordinates[1];
        const latitude = space.coordinates[0];
        const zoom = 15;
        const calcWidth = Math.trunc(setWindowWidth);
        const width = calcWidth > 500 ? 500 : calcWidth;
        const height = 200;
        const pin = `pin-l+ff0000(${longitude},${latitude})`
        return `https://api.mapbox.com/styles/v1/ruipgs/clpfirdnx00fs01o035qt9fwq/static/${pin}/${longitude},${latitude},${zoom}/${width}x${height}@2x?access_token=${mapbp.api_key}`
    }, [mapbp.api_key, windowWidth])



    const getMapboxImage = useCallback(async () => {
        if (!space) return;
        const res = await fetch(getMapboxStaticImageUrl(space));
        const blob = await res.blob();

        setImgSrc(URL.createObjectURL(blob));
        setMapsUrl(getGoogleMapsUrl(space));

    }, [getMapboxStaticImageUrl, space])


    useEffect(() => {
        getMapboxImage();
    }, [getMapboxImage])

    return { imageSource, mapsUrl }

}